import { shipmentIndexValidate } from "../../application/dtos/shipment_index_validate";

export class shipmentIndexEntity {
    constructor({ id, unique_order_number, shipment_number, label_download, note_download, shipping_service, total, date, client, time, last_status, return_date }){
        this.id = id;
        this.unique_order_number = unique_order_number;
        this.shipment_number = shipment_number;

        // IN PROCESS
        this.label_download = label_download;
        this.note_download = note_download;
        this.time = time;

        // SENT 
        this.last_status = last_status;

        // RETURN 
        this.return_date = return_date;

        this.shipping_service = shipping_service;
        this.total = total;
        this.date = date;
        this.client = client;
    }

    isValid() {
        return shipmentIndexValidate(this);
    }
}